import { CarrierType, CarrierVisitsApi, CarrierVisitStatus } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class CarrierVisitService {
  private readonly httpClient = createApiClient(CarrierVisitsApi)

  async getCarrierVisits(
    ids?: number[],
    carrierType?: CarrierType,
    status?: CarrierVisitStatus,
    startDate?: string,
    endDate?: string,
  ) {
    const { data } = await this.httpClient.getCarrierVisits(
      ids,
      carrierType,
      status,
      startDate,
      endDate,
    )

    return data
  }
}

export const carrierVisitService = new CarrierVisitService()
